import './SubPage.scss';
import Component from './SubPage.js';
export default Component;
